import { IFeaturedAd } from '../featured-ad';

export interface IBlock {
    type: 'FeaturedAd';
    content: IFeaturedAd;
}

export interface IPage {
    blocks: IBlock[];
}

export interface IPageFetcher {
    fetch: (id: string) => Promise<IPage>;
}

export async function getPage (id: string, client: IPageFetcher): Promise<IPage> {
    return client.fetch(id);
}
